import { searchWithinStyles } from "@insite/content-library/Widgets/ProductList/ProductListSearchWithin";
import Search from "@insite/mobius/Icons/Search";
import { css } from "styled-components";

searchWithinStyles.searchTextField = {
    iconProps: { src: Search },
        cssOverrides: {
            formField: css`
                width: 100%;
                > div[class^="FormInputWrapper"] {
                    > input {
                        background: #f1f1f1;
                        border: 0px;
                        border-bottom: 2px solid #ccc;
                        border-radius: 0px;
                        margin-bottom: 8px;
                    }
                }
            `,
        },
}